// Faithful formatting of data fields — no interpretation. Every string a
// user reads is either a verbatim field value or a unit conversion of one.

// The liquids limit as an amount: millilitres, or litres when a round 1000s.
// Returns "" when the datum is absent so nothing is invented.
export function liquidsAmount(limit: number | null | undefined): string {
  if (limit == null) return "";
  if (limit >= 1000 && limit % 1000 === 0) return `${limit / 1000} L`;
  return `${limit} ml`;
}

// Electronics in/out — the meaning of `coverage` (CT lanes = stay in the bag).
// A fixed lookup over the enum, not free prose.
const ELECTRONICS: Record<string, string> = {
  full: "stay in bag",
  partial: "some lanes",
  none: "come out",
  unknown: "",
};

export function electronicsLabel(coverage: string): string {
  return ELECTRONICS[coverage] ?? "";
}

// Country flag emoji from an ISO-2 code (regional indicator letters).
export function flagEmoji(code: string | undefined): string {
  if (!code || code.length !== 2) return "";
  const base = 0x1f1e6;
  const points = [...code.toUpperCase()].map(
    (letter) => base + letter.charCodeAt(0) - 65,
  );
  return String.fromCodePoint(...points);
}
